// UserManagementContext.js
import { createContext } from "react";

export const UserManagementContext = createContext();
export { UserManagementProvider } from './UserManagementContext.jsx';
